// --------------------------------------------------------------
// Created On: 2025-04-03
// Author: Dimitra Weinstein
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import DotLoader from "../../../components/DotLoader/DotLoader";
import styles from "../QuickOrderPage.module.scss";

// This component is used to search for a part number in the quick order page.
export default function QuickOrderForm(props: Props): Component {
  // This function handles changes made in the input field.
  function handleInputChange(e: React.ChangeEvent<HTMLInputElement>) {
    props.onInputValueChange(e.target.value), props.onErrorMessageChange("");
  }

  // This function handles the Enter key press event to perform a search.
  function handleKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === "Enter") {
      e.preventDefault();
      props.onErrorMessageChange("");
      props.onPerformSearch();
    }
  }

  // This function handles the search button click event.
  function handleSearch(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault(), props.onPerformSearch();
  }
  return props.loading ? (
    <DotLoader loading={true} className="justify-content-center align-items-center" isLarge />
  ) : (
    <form
      data-test="quick-order-form"
      className={`row m-2 g-3 p-3 justify-content-center align-content-center ${styles.quickOrderPage} border-top border-bottom`}
    >
      {/* Part Number Search Input */}
      <div className="col-4 mb-3 justify-content-center">
        <label className="mx-2 mb-1 fw-medium" htmlFor="partNumber">
          Part Number
        </label>
        <input
          data-test="quick-order-form-part-number-search-input"
          className="form-control"
          type="search"
          id="partNumber"
          name="partNumber"
          placeholder="Enter part number"
          value={props.inputValue}
          onChange={(e) => handleInputChange(e)}
          onKeyDown={(e) => handleKeyDown(e)}
          required
        />
      </div>
      {/* Search Button */}
      <div className="col-1 pt-2 align-content-center justify-content-center">
        <button
          data-test="quick-order-form-part-number-search-button"
          className="btn btn-md btn-primary"
          type="button"
          onClick={(e) => handleSearch(e)}
        >
          <i className="fa fa-fw fa-search" />
        </button>
      </div>
    </form>
  );
}

interface Props {
  loading: boolean;
  partFound: boolean;
  errorMessage: string;
  inputValue: string;
  searchComplete: boolean;
  onPerformSearch: () => void;
  onSearchComplete: (complete: boolean) => void;
  onLoadingChange: (loading: boolean) => void;
  onErrorMessageChange: (errorMessage: string) => void;
  onInputValueChange: (inputValue: string) => void;
}
